// frontend/src/services/payment.js
import api from './api';

/**
 * Payment and Subscription Service
 * Handles Stripe checkout sessions and subscription management
 */

const paymentService = {
  /**
   * Create a Stripe Checkout session for an annual subscription.
   * @param {string} tier - 'basic' or 'pro' (internal key; 'pro' displays as "Max")
   * @returns {Promise<{checkout_url: string, session_id: string}>}
   */
  async createSubscriptionCheckout(tier) {
    const response = await api.post(`/api/payments/create-checkout-session/subscription/${tier}`);
    return response.data;
  },

  /**
   * Create a Stripe Customer Portal session for managing subscription
   * @returns {Promise<{portal_url: string}>}
   */
  async createPortalSession() {
    const response = await api.post('/api/payments/create-portal-session');
    return response.data;
  },

  /**
   * Get current user's subscription status
   * @returns {Promise<Object>}
   */
  async getSubscriptionStatus() {
    const response = await api.get('/api/payments/subscription-status');
    return response.data;
  },

  /**
   * Redirect to Stripe Checkout
   * @param {string} checkoutUrl - Stripe checkout URL
   */
  redirectToCheckout(checkoutUrl) {
    window.location.href = checkoutUrl;
  },

  /**
   * Redirect to Stripe Customer Portal
   * @param {string} portalUrl - Stripe portal URL
   */
  redirectToPortal(portalUrl) {
    window.location.href = portalUrl;
  }
};

export default paymentService;
